import { getModels } from "api/queries/models";
import { AxiosResponse } from "axios";
import { useInfiniteQuery, UseInfiniteQueryResult } from "react-query";
import { IMetaSecond, IServerGetResponse } from "rules/interface/api/response";
import { IModels } from "rules/interface/models/models.interface";
import IModelsParams from "rules/interface/models/models.interface-params";



export function useGetModelsInfinity({ filters = null, params = null, options = {} }: IModelsParams): UseInfiniteQueryResult<AxiosResponse<IServerGetResponse<IModels[], IMetaSecond>>> {
    const encodeFilters = encodeURI(JSON.stringify(filters))

    return useInfiniteQuery(
        ["models-infinity", filters, params, options],
        ({ pageParam = 0 }) => getModels(pageParam, encodeFilters, { ...params }) as any,
        {
            ...options,
            getNextPageParam: lastPage => {
                const { page, totalCount } = lastPage.data.meta;
                return ((page * (params?.limit ?? 10)) < totalCount) ? (page + 1) : undefined;
            },
        },
    );
}